export default __webpack_public_path__ + "static/media/professor.9ad92ea0.png";